const domain: string = 'YOUFIRST_FILES'

export const SAVE_FILES: string = `${domain}/SAVE_FILES`
